import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { config } from '../../config/config';
import { showToast } from '../../components/utils/Toast';

const authHeader = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

const json = async (res) => {
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || 'Request failed');
  return data;
};

export const fetchTrades = createAsyncThunk(
  'trades/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const res = await fetch(`${config.apiUrl}/api/trades`, { headers: authHeader() });
      const data = await json(res);
      return data.trades;
    } catch (e) { return rejectWithValue(e.message); }
  }
);

export const createTrade = createAsyncThunk(
  'trades/create',
  async (payload, { rejectWithValue }) => {
    try {
      const res = await fetch(`${config.apiUrl}/api/trades`, {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await json(res);
      return data.trade;
    } catch (e) { return rejectWithValue(e.message); }
  }
);

export const updateTrade = createAsyncThunk(
  'trades/update',
  async ({ id, updates }, { rejectWithValue }) => {
    try {
      const res = await fetch(`${config.apiUrl}/api/trades/${id}`, {
        method: 'PUT',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(updates)
      });
      const data = await json(res);
      return data.trade;
    } catch (e) { return rejectWithValue(e.message); }
  }
);

export const deleteTrade = createAsyncThunk(
  'trades/delete',
  async (id, { rejectWithValue }) => {
    try {
      const res = await fetch(`${config.apiUrl}/api/trades/${id}`, {
        method: 'DELETE',
        headers: authHeader()
      });
      await json(res);
      return id;
    } catch (e) { return rejectWithValue(e.message); }
  }
);

const slice = createSlice({
  name: 'trades',
  initialState: { items: [], loading: false, error: null },
  reducers: {},
  extraReducers: (b) => {
    b.addCase(fetchTrades.pending, (s) => { s.loading = true; });
    b.addCase(fetchTrades.fulfilled, (s, a) => { s.loading = false; s.items = a.payload; });
    b.addCase(fetchTrades.rejected, (s, a) => { s.loading = false; s.error = a.payload; });
    b.addCase(createTrade.fulfilled, (s, a) => {
      s.items.push(a.payload);
      s.items.sort((x, y) => (x.name || '').localeCompare(y.name || ''));
      showToast('Trade added', 'success');
    });
    b.addCase(createTrade.rejected, (_, a) => { showToast(a.payload, 'error'); });
    b.addCase(updateTrade.fulfilled, (s, a) => {
      const i = s.items.findIndex((t) => t._id === a.payload._id);
      if (i >= 0) s.items[i] = a.payload;
      showToast('Trade updated', 'success');
    });
    b.addCase(updateTrade.rejected, (_, a) => { showToast(a.payload, 'error'); });
    b.addCase(deleteTrade.fulfilled, (s, a) => {
      s.items = s.items.filter((t) => t._id !== a.payload);
      showToast('Trade removed', 'success');
    });
    b.addCase(deleteTrade.rejected, (_, a) => { showToast(a.payload, 'error'); });
  }
});

export default slice.reducer;
